import { FC } from 'react';

import { Modal } from '@smartshell/ui-kit';

import { PostPaymentModalContent } from './components';
import { IPostPaymentsModalProps } from './interfaces';
import s from './PostPaymentsModal.module.scss';

export const PostPaymentsModal: FC<IPostPaymentsModalProps> = ({
  payment,
  onClose,
}) => {
  if (!payment) return null;

  return (
    <Modal className={s.modal} onClose={onClose}>
      <PostPaymentModalContent
        payment={payment}
        onClose={onClose}
        type="payment"
      />
    </Modal>
  );
};
